import { Menu } from "antd"
import { PortTypes } from "../../constant"
import { Node } from "@antv/x6"
import { v4 as uuidv4 } from "uuid";
import { NodeShapes, NozzleRecord } from "../../services/modal"
import { Flip, NozzleDirection, NozzleType } from "@/types/common"
import { useContext } from "react"
import { FlowsheetContext } from "../../FlowsheetProvider"
import { CheckOutlined } from "@ant-design/icons"

interface NodeContextMenuProps {
  afterSelected: () => void
  node: Node
}

export const NodeContextMenu = ({afterSelected, node }: NodeContextMenuProps) => {
  const data = node.getData()
  const flip = data.flip || Flip.None
  const {changeCellProps} = useContext(FlowsheetContext)

  const updateUnitProps = (changes) => {
    changeCellProps(node.id, changes)
  }


  const items = [
    {key: 'flip', label: 'Flip', children: [
      {key: 'flipNone', label: 'None', disabled: flip === Flip.None},
      {key: 'flipX', label: 'X', disabled: flip === Flip.X},
      {key: 'flipY', label: 'Y', disabled: flip === Flip.Y},
    ]}
  ]

  const onSelect = (item) => {
    const {key} = item;
    switch (key) {
      case 'flipX': {
        updateUnitProps({flip: Flip.X})
        return;
      }
      case 'flipNone': {
        updateUnitProps({flip: Flip.None})
        return;
      }
      case 'flipY': {
        updateUnitProps({flip: Flip.Y})
        return;
      }
      default:
        break;
    }
  }

  if (![NodeShapes.SvgNode, NodeShapes.SvgStream].includes(node.shape as NodeShapes) ) {
    return null
  }

  return <Menu className='orbit-context-menu' items={items} onSelect={onSelect} />
}